"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
var Events;
(function (Events) {
    let Type;
    (function (Type) {
        Type["BLOCKCHAIN"] = "blockchain";
        Type["CATALYST_DEPLOYMENT"] = "catalyst-deployment";
        Type["CLIENT"] = "client";
        Type["MARKETPLACE"] = "marketplace";
        Type["REWARDS"] = "rewards";
        Type["BADGE"] = "badge";
    })(Type = Events.Type || (Events.Type = {}));
    let SubType;
    (function (SubType) {
        let Blockchain;
        (function (Blockchain) {
            Blockchain["BID_ACCEPTED"] = "bid-accepted";
            Blockchain["ITEM_SOLD"] = "item-sold";
            Blockchain["RENTAL_ENDED"] = "land-rental-ended";
            Blockchain["RENTAL_STARTED"] = "land-rental-started";
            Blockchain["ROYALTIES_EARNED"] = "royalties-earned";
            Blockchain["COLLECTION_CREATED"] = "collection-created";
        })(Blockchain = SubType.Blockchain || (SubType.Blockchain = {}));
        let Marketplace;
        (function (Marketplace) {
            Marketplace["BID_RECEIVED"] = "bid-received";
        })(Marketplace = SubType.Marketplace || (SubType.Marketplace = {}));
        let CatalystDeployment;
        (function (CatalystDeployment) {
            CatalystDeployment["SCENE"] = "scene";
            CatalystDeployment["PROFILE"] = "profile";
            CatalystDeployment["WEARABLE"] = "wearable";
            CatalystDeployment["STORE"] = "store";
            CatalystDeployment["EMOTE"] = "emote";
            CatalystDeployment["OUTFITS"] = "outfits";
        })(CatalystDeployment = SubType.CatalystDeployment || (SubType.CatalystDeployment = {}));
        let Client;
        (function (Client) {
            Client["MOVE_TO_PARCEL"] = "move-to-parcel";
            Client["USED_EMOTE"] = "used-emote";
        })(Client = SubType.Client || (SubType.Client = {}));
        let Rewards;
        (function (Rewards) {
            Rewards["REWARD_IN_PROGRESS"] = "reward-in-progress";
            Rewards["REWARD_ASSIGNED"] = "reward-assigned";
            Rewards["CAMPAIGN_OUT_OF_FUNDS"] = "campaign-out-of-funds";
            Rewards["CAMPAIGN_GAS_PRICE_HIGHER_THAN_EXPECTED"] = "campaign-gas-price-higher-than-expected";
            Rewards["CAMPAIGN_OUT_OF_STOCK"] = "campaign-out-of-stock";
            Rewards["REWARD_DELAYED"] = "reward-delayed";
        })(Rewards = SubType.Rewards || (SubType.Rewards = {}));
        let Badge;
        (function (Badge) {
            Badge["GRANTED"] = "badge-granted";
        })(Badge = SubType.Badge || (SubType.Badge = {}));
    })(SubType = Events.SubType || (Events.SubType = {}));
})(Events = exports.Events || (exports.Events = {}));
//# sourceMappingURL=base.js.map